<template>
    <div>
        <div id="body-wrap">
            <LayoutHeader title="변화의 은평" color="bg-green">
                <ul slot="navigator" class="category_list">
                    <li>홈</li>
                    <li>변화의 은평</li>
                </ul>
            </LayoutHeader>
            <Biz />
        </div>
    </div>
</template>
<script>
import LayoutHeader from '@/views/layout/LayoutHeader.vue';
import Biz from '@/views/biz/Biz.vue';
import { mapGetters } from 'vuex';

export default {
    name: 'BizApp',
    data() {
        return {}
    },
    computed: {
        ...mapGetters({}),
    },
    created() {
        let proms = [];
        //proms.push(this.$store.dispatch('FETCH_INDICATOR_CATE_LIST'))
        //proms.push(this.$store.dispatch('FETCH_INDICATOR_LIST'))
        Promise.all(proms)
            .then(function() {

            });

    },
    methods: {},
    components: {
        LayoutHeader,
        Biz,
    },

}
</script>
